import { Component, ElementRef, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { JEService } from 'src/app/services/je-services.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-vendor-registrations',
  templateUrl: './vendor-registrations.component.html',
  styleUrls: ['./vendor-registrations.component.scss']
})
export class VendorRegistrationsComponent implements OnInit {
  @ViewChild('dataTable') tableContainer: ElementRef;
  @Output() mobilenumberEmit = new EventEmitter<string>();

  public subActionType: string = "CompletedApps";
  public finYear: any;
  vendorCode:any;
  userType:any;
  public miTableData: any = [];
  public actionTypesFromTableData: any = [];
  public miCompletedFilterList: any = [];
  public subscriptions: any = [];
  public userId: any;
  // public selectedMICompletedFilter: null;
  public vendorRegId: any;
  public micada1Data: any;
  actionId: any = 18;
  public miTableDataWithFilter: any = [];
  public tableHeaderName = 'Registered Vendor Details';
  miCompletedReport: MenuItem[];
  loading: boolean;
  items: any[];
  selectedStatus: any;
  constructor(private reportsService: ReportsService,private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService,
    private jeService: JEService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private cryptoJsService: CryptoJsService,
              private router: Router) { }

  ngOnInit(): void {

    this.finYear = 'All';
    if(this.finYear == 'All'){
      this.finYear = '';
    }
    this.loadMIDataUnderProcess();
    // this.loadMIDataUnderProcess();
    // setTimeout( () => this.tableContainer.nativeElement.scrollIntoView({
    //   block: "center",
    //   behavior: "smooth"
    // }), 400)
    
    // let sessionToken = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    // this.vendorCode=JSON.parse(sessionToken).officeCode

    this.miCompletedReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.micada1Data, `Registered Vendor List`);
        },
      },
    ];
  }
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Vendor Name': d.Vendor_Name,
          'Registration Type': d.RegistrationType,
          'Manufacturer/ Sub-Manufacturer': d.SupManufactureNames,
          'Date of Incorporation': d.Date_of_Incorporation,
          'Mobile': d?.Mobile,
          'Registration Email Id': d?.Email_ID,
          'Officail Email Id': d?.Officical_Email_ID,
          'GST No': d?.GST_No,
          'Address': `${d.Address}, ${d.City}, ${d.State}, ${d.Country}.`,
          'TAN No': d.TAN_No,
          'PAN No': d.PAN_No,
          'Bank Name': d.Bank_Name,
          'Account Number': d.Account_Number,
          'IFSC Code': d.IFSC_Code,
          'DD Amount': d.Amount,
          'DD Number': d.DDNumber,
          'DD Bank Name': d.DDBankName,
          'DD Date': d.DD_Date,
          'Programme Name': d.ProgramNames,
          'Status': d.Status,
          'Remarks': d.Remarks,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  // loadMIDataUnderProcess(subActionType) {
  //   // this.loader.start();
  //   this.loading = true;
  //   let sub = this.reportsService
  
  //     .getVendorGridData(this.userId)
  //     .pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         this.loading = false;
  //         if (data?.length > 0) {
  //           this.miTableData = data;
  //           this.miTableDataWithFilter = data;
  //           this.actionTypesFromTableData, this.miCompletedFilterList = this.getUniqueActionType(data);

  //         }else{
  //           this.miTableData = [];
  //           this.miTableDataWithFilter = [];
  //           this.actionTypesFromTableData = [];
  //         }
  //       },
  //       error: (err) => {
  //         // this.loading = false;
  //         this.loading = false;
  //         this.miTableData = [];
  //         this.miTableDataWithFilter = [];
  //         this.actionTypesFromTableData = [];
  //       },
  //     });

  //     this.subscriptions.push(sub);
  // }
  loadMIDataUnderProcess() {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    this.vendorRegId = JSON.stringify(token?.officeCode);
    // let payload = atob(token?.value?.authToken?.split('.')[1]);
     
    if(this.router.url.startsWith('/xen')){
      this.actionId = 18;
    }
    else if(this.router.url.startsWith('/department')){
      this.actionId = 2;
    }
    this.deptDashBoardService
      .GetStatusMaster(JSON.parse(payload)?.sub, this.actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.items = data.$values;
          this.selectedStatus = this.items[0]?.status;
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master cant be Loaded',
          });
        },
      });

    this.loader.start();
    this.jeService
      .getVendorGridData(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          this.userId = JSON.parse(payload)?.sub;
          if (data.length > 0) {
            this.micada1Data = data;
          }else{
            this.micada1Data=[];
            
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: "Data Not Found",
            });
          }
        },
        error: (err) => {
          this.micada1Data=[];
          this.loader.close();

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getUniqueActionType(data) {
    const actionLevelSet = new Set(data.map(entry => entry.nextuser));
    const actionLevelObjects = Array.from(actionLevelSet).map(actionLevel => ({ actionLevel }));
    
    return actionLevelObjects;
  }
  printForm(AppID) {
    
    if (AppID) {
      let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      this.userId = JSON.parse(payload)?.sub;
      if(this.userId == 'admin'){
        this.router.navigate(['admin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['admin', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId == 'CAO'){
        this.router.navigate(['cao', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['cao', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId == 'DD-EW'){
        this.router.navigate(['ew-department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['ew-department', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId== 'Vendor'){
        this.router.navigate(['vendor', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(AppID)]);
        
      }else if(this.userId== 'webadmin'){
        this.router.navigate(['webadmin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else {
        this.router.navigate(['department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(AppID.toString()) } });
        // this.router.navigate(['department', 'print', this.cryptoJsService.Encrypt(AppID)])
        
      }
    }
  }

  selectPhysicalVerAppln(application: any, viewType: string) {
    this.activityRecordService.activityRecord(this.userId, 'Vendor Registration View Action', application?.PAN_No, new Date(), 'Success');
    if (application.Email_ID) {
      // sessionStorage.setItem('MISelectedAppType', 'vendor-registrations');
      let encryptedAutoId = this.cryptoJsService.Encrypt(application.TAN_No.toString());
      let encryptedAppId = this.cryptoJsService.Encrypt(application.PAN_No.toString());
      // this.router.navigate([this.router.url.split('/')[1], 'vendor-data'], { queryParams: { TAN_No: encryptedAutoId, PAN_No: encryptedAppId } });
      // mobilenumberEmit
      this.mobilenumberEmit.emit(this.cryptoJsService.Encrypt(application.Email_ID.toString()));
      this.router.navigate([this.router.url.split('/')[1], 'vendor-data'], { queryParams: { email:this.cryptoJsService.Encrypt(application.Email_ID.toString()), viewType: this.cryptoJsService.Encrypt(viewType), status: this.cryptoJsService.Encrypt(application?.Status) } });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
    }
  }

  rowBackgroundColor(row) {
    if (row.Status == 'Pending' || row.Status == null) {
      return '#ffffff';
      // return '#ffc966' //yellow;
    } else if (row.Status == 'Objection Raised') {
      return '#ffb3b3';
    } else if (row.Status == 'Approved') {
      return '#99e699';
    }else if (row.Status == 'Rejected') {
      return '#ff8080';
    } else return '#ffffff';
  }
}
